import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import WOW from 'wowjs';
import './css/animate.css';
import './css/glightbox.min.css';
import './css/LandingPage.css';
import './css/lineicons.css';
import './css/style.css';
import Logo from '../Logo'
import Cards from './Cards'
const Landing = () => {
  useEffect(() => {
    const wow = new WOW.WOW();
    wow.init();
    const script = document.createElement('script');
    script.src = "/landingFolder/landing/js/main.js";
    script.defer = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    }
  }, [])
  return (
    <div id="landingPage">
      {/* <!--====== HEADER PART START ======--> */}
      <header className="header-area">
        <div className="navbar-area">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <nav className="navbar navbar-expand-lg">
                  <a className="navbar-brand" href="/">
                    {/* <img src="/images/AirBook-b.png" style={{width:"150px",height:"auto"}} alt="Logo" /> */}
                    <Logo />
                  </a>
                  <button
                    className="navbar-toggler"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarSupportedContent"
                    aria-controls="navbarSupportedContent"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                  >
                    <span className="toggler-icon"> </span>
                    <span className="toggler-icon"> </span>
                    <span className="toggler-icon"> </span>
                  </button>

                  <div
                    className="collapse navbar-collapse sub-menu-bar"
                    id="navbarSupportedContent"
                  >
                    <ul id="nav" className="navbar-nav ms-auto">
                      <li className="nav-item">
                        <a className="page-scroll active" href="#home">Home</a>
                      </li>
                      <li className="nav-item">
                        <a className="page-scroll" href="#features">Features</a>
                      </li>
                      <li className="nav-item">
                        <a className="page-scroll" href="#about">About</a>
                      </li>
                      {/* <li className="nav-item">
                        <a className="page-scroll" href="#facts">Why</a>
                      </li> */}
                      <li className="nav-item">
                        <a href="#pricing">Pricing</a>
                      </li>
                      <li className="nav-item">
                        <Link to="/signin">Login</Link>
                        {/* <a href="/signin">Login</a> */}
                      </li>
                    </ul>
                  </div>
                  {/* <!-- navbar collapse --> */}

                  <div className="navbar-btn d-none d-sm-inline-block">
                    <a
                      className="main-btn"
                      data-scroll-nav="0"
                      href="#"
                      rel="nofollow"
                    >
                      Get Started
                    </a>
                  </div>
                </nav>
                {/* <!-- navbar --> */}
              </div>
            </div>
            {/* <!-- row --> */}
          </div>
          {/* <!-- container --> */}
        </div>
        {/* <!-- navbar area --> */}

        <div
          id="home"
          className="header-hero bg_cover"
          style={{ backgroundImage: 'url(landingFolder/landing/images/header/banner-bg.svg)' }}
        >
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="header-hero-content text-center">
                  <h2
                    className="header-sub-title wow fadeInUp headingsty mb-3"
                    data-wow-duration="1.3s"
                    data-wow-delay="0.2s"
                  >
                    Portal where student can access study materials
                  </h2>
                  <h3
                    className="header-title wow fadeInUp headingsty"
                    data-wow-duration="1.3s"
                    data-wow-delay="0.5s"
                  >
                    Focuses on on-campus teaching material
                  </h3>
                  <h4
                    className="text wow fadeInUp"
                    data-wow-duration="1.3s"
                    data-wow-delay="0.8s"
                  >
                    Helps learner to learn more efficiently,effectively,flexibly and comfortably
                  </h4>
                  <a
                    href="javascript:void(0)"
                    className="main-btn wow fadeInUp"
                    data-wow-duration="1.3s"
                    data-wow-delay="1.1s"
                  >
                    Get Started
                  </a>
                </div>
                {/* <!-- header hero content --> */}
              </div>
            </div>
            {/* <!-- row --> */}
            <div className="row">
              <div className="col-lg-12">
                <div
                  className="header-hero-image text-center wow fadeIn"
                  data-wow-duration="1.3s"
                  data-wow-delay="1.4s"
                >
                  <img src="images/lap1.png" alt="hero" />
                </div>
                {/* <!-- header hero image --> */}
              </div>
            </div>
            {/* <!-- row --> */}
          </div>
          {/* <!-- container --> */}
          <div id="particles-1" className="particles"></div>
        </div>
        {/* <!-- header hero --> */}
      </header>
      {/* <!--====== HEADER PART ENDS ======--> */}

      <Cards />
      {/* <!--====== SERVICES PART START ======--> */}
      <section id="features" className="services-area pt-120">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <div className="section-title text-center pb-40">
                <div className="line m-auto"></div>
                <h3 className="title headingsty h3">
                  Clean and simple design,
                  <span> Comes with everything you need to get started!</span>
                </h3>
              </div>
              {/* <!-- section title --> */}
            </div>
          </div>
          {/* <!-- row --> */}
          <div className="row justify-content-center">
            <div className="col-lg-4 col-md-7 col-sm-8">
              <div
                className="single-services text-center mt-30 wow fadeIn"
                data-wow-duration="1s"
                data-wow-delay="0.2s"
              >
                <div className="services-icon">
                  <img
                    className="shape"
                    src="landingFolder/landing/images/services/services-shape.svg"
                    alt="shape"
                  />
                  <img
                    className="shape-1"
                    src="landingFolder/landing/images/services/services-shape-1.svg"
                    alt="shape"
                  />
                  <i className="lni lni-baloon"> </i>
                </div>
                <div className="services-content mt-30">
                  <h4 className="services-title headingsty h4">
                    <a href="javascript:void(0)">Simple</a>
                  </h4>
                  <p className="text">
                    Simple user interface ,easy to understand the flow of architecture.
                  </p>
                  {/* <a className="more" href="javascript:void(0)"
                  >Learn More <i className="lni lni-chevron-right"> </i>
                  </a> */}
                </div>
              </div>
              {/* <!-- single services --> */}
            </div>
            <div className="col-lg-4 col-md-7 col-sm-8">
              <div
                className="single-services text-center mt-30 wow fadeIn"
                data-wow-duration="1s"
                data-wow-delay="0.5s"
              >
                <div className="services-icon">
                  <img
                    className="shape"
                    src="landingFolder/landing/images/services/services-shape.svg"
                    alt="shape"
                  />
                  <img
                    className="shape-1"
                    src="landingFolder/landing/images/services/services-shape-2.svg"
                    alt="shape"
                  />
                  <i className="lni lni-cog"> </i>
                </div>
                <div className="services-content mt-30">
                  <h4 className="services-title headingsty h4">
                    <a href="javascript:void(0)">Portable</a>
                  </h4>
                  <p className="text">
                    Build with latest technology stack,helps students to access study materials on any device entire their course duration.
                  </p>
                  {/* <a className="more" href="javascript:void(0)"
                  >Learn More <i className="lni lni-chevron-right"> </i>
                  </a> */}
                </div>
              </div>
              {/* <!-- single services --> */}
            </div>
            <div className="col-lg-4 col-md-7 col-sm-8">
              <div
                className="single-services text-center mt-30 wow fadeIn"
                data-wow-duration="1s"
                data-wow-delay="0.8s"
              >
                <div className="services-icon">
                  <img
                    className="shape"
                    src="landingFolder/landing/images/services/services-shape.svg"
                    alt="shape"
                  />
                  <img
                    className="shape-1"
                    src="landingFolder/landing/images/services/services-shape-3.svg"
                    alt="shape"
                  />
                  <i className="lni lni-bolt-alt"> </i>
                </div>
                <div className="services-content mt-30">
                  <h4 className="services-title headingsty h4">
                    <a href="javascript:void(0)">Powerful</a>
                  </h4>
                  <p className="text">
                    Portal is supported by distributed cloud architecture.
                  </p>
                  {/* <a className="more" href="javascript:void(0)"
                  >Learn More <i className="lni lni-chevron-right"> </i>
                  </a> */}
                </div>
              </div>
              {/* <!-- single services --> */}
            </div>
          </div>
          {/* <!-- row --> */}
        </div>
        {/* <!-- container --> */}
      </section>
      {/* <!--====== SERVICES PART ENDS ======--> */}

      <section id="about">
        {/* <!--====== ABOUT PART START ======--> */}
        <div className="about-area pt-70">
          <div className="container">
            <div className="row">
              <div className="col-lg-6">
                <div
                  className="about-content mt-50 wow fadeInLeftBig"
                  data-wow-duration="1s"
                  data-wow-delay="0.5s"
                >
                  <div className="section-title">
                    <div className="line"></div>
                    <h3 className="title headingsty h3">
                      Easy <span>to Use</span>
                    </h3>
                  </div>
                  {/* <!-- section title --> */}
                  <p className="text">
                    AirBook is a portal where students can access study materials like ppts,assignment questions ,archieved question papers upto course duration.
                  </p>
                  <a href="javascript:void(0)" className="main-btn">Try it Free</a>
                </div>
                {/* <!-- about content --> */}
              </div>
              <div className="col-lg-6">
                <div
                  className="about-image text-center mt-50 wow fadeInRightBig"
                  data-wow-duration="1s"
                  data-wow-delay="0.5s"
                >
                  <img src="landingFolder/landing/images/about/about1.svg" alt="about" />
                </div>
                {/* <!-- about image --> */}
              </div>
            </div>
            {/* <!-- row --> */}
          </div>
          {/* <!-- container --> */}
          <div className="about-shape-1">
            <img src="landingFolder/landing/images/about/about-shape-1.svg" alt="shape" />
          </div>
        </div>
        {/* <!--====== ABOUT PART ENDS ======--> */}

        {/* <!--====== ABOUT PART START ======--> */}
        <div className="about-area pt-70">
          <div className="about-shape-2">
            <img src="landingFolder/landing/images/about/about-shape-2.svg" alt="shape" />
          </div>
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-6 order-lg-last">
                <div
                  className="about-content ms-lg-auto mt-50 wow fadeInLeftBig"
                  data-wow-duration="1s"
                  data-wow-delay="0.5s"
                >
                  <div className="section-title">
                    <div className="line"></div>
                    <h3 className="title headingsty h3">
                      portal <span> with Essential Features</span>
                    </h3>
                  </div>
                  {/* <!-- section title --> */}
                  <p className="text">
                    Helps the student to learn more efficiently,effectively,flexbly and comfortably.Easy to understand the user interface.
                  </p>
                  <a href="javascript:void(0)" className="main-btn">Try it Free</a>
                </div>
                {/* <!-- about content --> */}
              </div>
              <div className="col-lg-6 order-lg-first">
                <div
                  className="about-image text-center mt-50 wow fadeInRightBig"
                  data-wow-duration="1s"
                  data-wow-delay="0.5s"
                >
                  <img src="landingFolder/landing/images/about/about2.svg" alt="about" />
                </div>
                {/* <!-- about image --> */}
              </div>
            </div>
            {/* <!-- row --> */}
          </div>
          {/* <!-- container --> */}
        </div>
        {/* <!--====== ABOUT PART ENDS ======--> */}

        {/* <!--====== ABOUT PART START ======--> */}
        <div className="about-area pt-70">
          <div className="container">
            <div className="row">
              <div className="col-lg-6">
                <div
                  className="about-content mt-50 wow fadeInLeftBig"
                  data-wow-duration="1s"
                  data-wow-delay="0.5s"
                >
                  <div className="section-title">
                    <div className="line"></div>
                    <h3 className="title headingsty h3">
                      {/* <span>Crafted for</span> SaaS, App and Software landingFolder/landing Page */}
                      Supported by<span> distributed cloud architecture</span>
                    </h3>
                  </div>
                  {/* <!-- section title --> */}
                  <p className="text">
                    Each faculty access the portal through an organization email,Files of respective faculty are stored in their own google drive. Maintenance cost of database is free and n no.of users can access the portal.
                  </p>
                  <a href="javascript:void(0)" className="main-btn">Try it Free</a>
                </div>
                {/* <!-- about content --> */}
              </div>
              <div className="col-lg-6">
                <div
                  className="about-image text-center mt-50 wow fadeInRightBig"
                  data-wow-duration="1s"
                  data-wow-delay="0.5s"
                >
                  <img src="landingFolder/landing/images/about/about3.svg" alt="about" />
                </div>
                {/* <!-- about image --> */}
              </div>
            </div>
            {/* <!-- row --> */}
          </div>
          {/* <!-- container --> */}
          <div className="about-shape-1">
            <img src="landingFolder/landing/images/about/about-shape-1.svg" alt="shape" />
          </div>
        </div>
        {/* <!--====== ABOUT PART ENDS ======--> */}
      </section>

      {/* <!--====== VIDEO COUNTER PART START ======--> */}
      <section id="facts" className="video-counter pt-70">
        <div className="container">
          <div className="row">
            <div className="col-lg-7 order-lg-last">
              <div
                className="counter-wrapper mt-50 wow fadeIn"
                data-wow-duration="1s"
                data-wow-delay="0.8s"
              >
                <div className="counter-content">
                  <div className="section-title">
                    <div className="line"></div>
                    <h3 className="title headingsty h3">Facts <span> about this portal</span></h3>
                  </div>
                  {/* <!-- section title --> */}
                  <p className="text">
                    Architecture flows along the hierarchy of role i.e Super-admin, Admin, Class coordinator, Fcaulty, Student. Go through the demo to understand indetail.
                  </p>
                </div>
                {/* <!-- counter content --> */}
                <div className="row no-gutters">
                  <div className="col-4">
                    <div
                      className="
                      single-counter
                      counter-color-1
                      d-flex
                      align-items-center
                      justify-content-center
                    "
                    >
                      <div className="counter-items text-center">
                        <span
                          // className="count countup text-uppercase"
                          className="count text-uppercase"
                        // cup-end="0"
                        >1</span>

                        <p className="text">Client</p>
                      </div>
                    </div>
                    {/* <!-- single counter --> */}
                  </div>
                  <div className="col-4">
                    <div
                      className="
                      single-counter
                      counter-color-2
                      d-flex
                      align-items-center
                      justify-content-center
                    "
                    >
                      <div className="counter-items text-center">
                        <span
                          className="count text-uppercase"
                        // cup-end="0"
                        >0</span>
                        <p className="text">Student Users</p>
                      </div>
                    </div>
                    {/* <!-- single counter --> */}
                  </div>
                  <div className="col-4">
                    <div
                      className="
                      single-counter
                      counter-color-3
                      d-flex
                      align-items-center
                      justify-content-center
                    "
                    >
                      <div className="counter-items text-center">
                        <span
                          className="count text-uppercase"
                        // cup-end="0"
                        >5/5</span>
                        <p className="text">User Rating</p>
                      </div>
                    </div>
                    {/* <!-- single counter --> */}
                  </div>
                </div>
                {/* <!-- row --> */}
              </div>
              {/* <!-- counter wrapper --> */}
            </div>
            <div className="col-lg-5">
              <div
                className="video-content mt-50 wow fadeIn"
                data-wow-duration="1s"
                data-wow-delay="0.5s"
              >
                <img className="dots" src="landingFolder/landing/images/video/dots.svg" alt="dots" />
                <div className="video-wrapper">
                  <div className="video-image">
                    <img src="images/AirBookwallpaper.jpg" alt="video" />
                  </div>
                  <div className="video-icon">
                    <a
                      href="https://youtu.be/rjY7OShqH5s"
                      className="video-popup glightbox"
                    >
                      <i className="lni lni-play"> </i>
                    </a>
                  </div>
                </div>
                {/* <!-- video wrapper --> */}
              </div>
              {/* <!-- video content --> */}
            </div>
          </div>
          {/* <!-- row --> */}
        </div>
        {/* <!-- container --> */}
      </section>
      {/* <!--====== VIDEO COUNTER PART ENDS ======--> */}
      {/* pricing */}
      <section id="pricing" className="pricing-area pt-70">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-6">
              <div className="section-title text-center pb-10">
                <h3 className="title headingsty h3">Our Pricing</h3>
                <p className="text">Stop wasting time and money designing and managing a website that doesn’t get results. Happiness guaranteed!</p>
              </div>
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-lg-4 col-md-7 col-sm-9">
              <div className="single-pricing mt-40">
                <div className="pricing-header text-center">
                  <h5 className="sub-title">Basic</h5>
                  <span className="price">Free</span>
                  <p className="year">2months</p>
                </div>
                <div className="pricing-list">
                  <ul>
                    <li><i className="lni-check-mark-circle"></i> unlimited users</li>
                    <li><i className="lni-check-mark-circle"></i> unlimted storage</li>
                    {/* <li><i className="lni-check-mark-circle"></i> Super friendly support team</li>
                                <li><i className="lni-check-mark-circle"></i> Awesome Support</li> */}
                  </ul>
                </div>
                <div className="pricing-btn text-center">
                  <a className="main-btn" href="#">GET STARTED</a>
                </div>
                <div className="buttom-shape">
                  {/* <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 350 112.35"><defs><style>.color-1{fill:#2bdbdc;isolation:isolate;}.cls-1{opacity:0.1;}.cls-2{opacity:0.2;}.cls-3{opacity:0.4;}.cls-4{opacity:0.6;}</style></defs><title>bottom-part1</title><g id="bottom-part"><g id="Group_747" data-name="Group 747"><path id="Path_294" data-name="Path 294" className="cls-1 color-1" d="M0,24.21c120-55.74,214.32,2.57,267,0S349.18,7.4,349.18,7.4V82.35H0Z" transform="translate(0 0)"/><path id="Path_297" data-name="Path 297" className="cls-2 color-1" d="M350,34.21c-120-55.74-214.32,2.57-267,0S.82,17.4.82,17.4V92.35H350Z" transform="translate(0 0)"/><path id="Path_296" data-name="Path 296" className="cls-3 color-1" d="M0,44.21c120-55.74,214.32,2.57,267,0S349.18,27.4,349.18,27.4v74.95H0Z" transform="translate(0 0)"/><path id="Path_295" data-name="Path 295" className="cls-4 color-1" d="M349.17,54.21c-120-55.74-214.32,2.57-267,0S0,37.4,0,37.4v74.95H349.17Z" transform="translate(0 0)"/></g></g></svg> */}
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-7 col-sm-9 blurimg">
              <div className="single-pricing pro mt-40">
                <div className="pricing-baloon">
                  <img src="images/baloon.svg" alt="baloon"></img>
                </div>
                <div className="pricing-header">
                  <h5 className="sub-title">Pro</h5>
                  <span className="price">2999/-</span>
                  <p className="year">per month</p>
                </div>
                <div className="pricing-list">
                  <ul>
                    {/* <li><i className="lni-check-mark-circle"></i> Carefully crafted components</li>
                                <li><i className="lni-check-mark-circle"></i> Amazing page examples</li>
                                <li><i className="lni-check-mark-circle"></i> Super friendly support team</li>
                                <li><i className="lni-check-mark-circle"></i> Awesome Support</li> */}
                    <li><i className="lni-check-mark-circle"></i> unlimited users</li>
                    <li><i className="lni-check-mark-circle"></i> unlimted storage</li>

                  </ul>
                </div>
                <div className="pricing-btn text-center">
                  <a className="main-btn" href="#">GET STARTED</a>
                </div>
                <div className="buttom-shape">
                  {/* <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 350 112.35"><defs><style>.color-2{fill:#0067f4;isolation:isolate;}.cls-1{opacity:0.1;}.cls-2{opacity:0.2;}.cls-3{opacity:0.4;}.cls-4{opacity:0.6;}</style></defs><title>bottom-part1</title><g id="bottom-part"><g id="Group_747" data-name="Group 747"><path id="Path_294" data-name="Path 294" className="cls-1 color-2" d="M0,24.21c120-55.74,214.32,2.57,267,0S349.18,7.4,349.18,7.4V82.35H0Z" transform="translate(0 0)"/><path id="Path_297" data-name="Path 297" className="cls-2 color-2" d="M350,34.21c-120-55.74-214.32,2.57-267,0S.82,17.4.82,17.4V92.35H350Z" transform="translate(0 0)"/><path id="Path_296" data-name="Path 296" className="cls-3 color-2" d="M0,44.21c120-55.74,214.32,2.57,267,0S349.18,27.4,349.18,27.4v74.95H0Z" transform="translate(0 0)"/><path id="Path_295" data-name="Path 295" className="cls-4 color-2" d="M349.17,54.21c-120-55.74-214.32,2.57-267,0S0,37.4,0,37.4v74.95H349.17Z" transform="translate(0 0)"/></g></g></svg> */}
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-7 col-sm-9 blurimg">
              <div className="single-pricing enterprise mt-40">
                <div className="pricing-flower">
                  <img src="images/flower.svg" alt="flower"></img>
                </div>
                <div className="pricing-header text-right">
                  <h5 className="sub-title">Pro +</h5>
                  <span className="price">4999/-</span>
                  <p className="year">per month</p>
                </div>
                <div className="pricing-list">
                  <ul>
                    {/* <li><i className="lni-check-mark-circle"></i> Carefully crafted components</li>
                                <li><i className="lni-check-mark-circle"></i> Amazing page examples</li>
                                <li><i className="lni-check-mark-circle"></i> Super friendly support team</li>
                                <li><i className="lni-check-mark-circle"></i> Awesome Support</li> */}
                    <li><i className="lni-check-mark-circle"></i> unlimited users</li>
                    <li><i className="lni-check-mark-circle"></i> unlimted storage</li>

                  </ul>
                </div>
                <div className="pricing-btn text-center">
                  <a className="main-btn" href="#">GET STARTED</a>
                </div>
                <div className="buttom-shape">
                  {/* <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 350 112.35"><defs><style>.color-3{fill:#4da422;isolation:isolate;}.cls-1{opacity:0.1;}.cls-2{opacity:0.2;}.cls-3{opacity:0.4;}.cls-4{opacity:0.6;}</style></defs><title>bottom-part1</title><g id="bottom-part"><g id="Group_747" data-name="Group 747"><path id="Path_294" data-name="Path 294" className="cls-1 color-3" d="M0,24.21c120-55.74,214.32,2.57,267,0S349.18,7.4,349.18,7.4V82.35H0Z" transform="translate(0 0)"/><path id="Path_297" data-name="Path 297" className="cls-2 color-3" d="M350,34.21c-120-55.74-214.32,2.57-267,0S.82,17.4.82,17.4V92.35H350Z" transform="translate(0 0)"/><path id="Path_296" data-name="Path 296" className="cls-3 color-3" d="M0,44.21c120-55.74,214.32,2.57,267,0S349.18,27.4,349.18,27.4v74.95H0Z" transform="translate(0 0)"/><path id="Path_295" data-name="Path 295" className="cls-4 color-3" d="M349.17,54.21c-120-55.74-214.32,2.57-267,0S0,37.4,0,37.4v74.95H349.17Z" transform="translate(0 0)"/></g></g></svg> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* <!--====== FOOTER PART START ======--> */}
      <footer id="footer" className="footer-area pt-120">
        <div className="container">
          <div
            className="subscribe-area wow fadeIn"
            data-wow-duration="1s"
            data-wow-delay="0.5s"
          >
            <div className="row">
              <div className="col-lg-6">
                <div className="subscribe-content mt-45">
                  <h2 className="subscribe-title headingsty h2">
                    Subscribe Our Newsletter <span>get reguler updates</span>
                  </h2>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="subscribe-form mt-50">
                  <form action="#">
                    <input type="text" placeholder="Enter eamil" />
                    <button className="main-btn">Subscribe</button>
                  </form>
                </div>
              </div>
            </div>
            {/* <!-- row --> */}
          </div>
          {/* <!-- subscribe area --> */}
          <div className="footer-widget pb-100">
            <div className="row">
              <div className="col-lg-5 col-md-6 col-sm-8">
                <div
                  className="footer-about mt-50 wow fadeIn d-flex"
                  data-wow-duration="1s"
                  data-wow-delay="0.2s"
                  style={{ flexDirection: "column", alignItems: "center" }}
                >
                  <a className="logo" href="javascript:void(0)">
                    <Logo />
                  </a>
                  {/* <p className="text">
                    Lorem ipsum dolor sit amet consetetur sadipscing elitr,
                    sederfs diam nonumy eirmod tempor invidunt ut labore et dolore
                    magna aliquyam.
                  </p> */}
                  <ul className="social">
                    <li>
                      <a href="javascript:void(0)">
                        <i className="lni lni-facebook-filled"> </i>
                      </a>
                    </li>
                    <li>
                      <a href="javascript:void(0)">
                        <i className="lni lni-twitter-filled"> </i>
                      </a>
                    </li>
                    <li>
                      <a href="javascript:void(0)">
                        <i className="lni lni-instagram-filled"> </i>
                      </a>
                    </li>
                    <li>
                      <a href="javascript:void(0)">
                        <i className="lni lni-linkedin-original"> </i>
                      </a>
                    </li>
                  </ul>
                </div>
                {/* <!-- footer about --> */}
              </div>
              <div className="col-lg-4 col-md-7 col-sm-12">
                <div className="footer-link d-flex mt-50 justify-content-sm-between">
                  <div
                    className="link-wrapper wow fadeIn"
                    data-wow-duration="1s"
                    data-wow-delay="0.4s"
                  >
                    <div className="footer-title">
                      <h4 className="title headingsty h4">Quick Link</h4>
                    </div>
                    <ul className="link">
                      <li><a href="#home">Home</a></li>
                      <li><a href="#features">Features</a></li>
                      <li><a href="#about">About</a></li>
                      <li><a href="#">Terms of Service</a></li>
                      <li><a href="#pricing">Pricing</a></li>
                    </ul>
                  </div>
                  {/* <!-- footer wrapper --> */}
                  {/* <div
                    className="link-wrapper wow fadeIn"
                    data-wow-duration="1s"
                    data-wow-delay="0.6s"
                  >
                    <div className="footer-title">
                      <h4 className="title headingsty h4">Resources</h4>
                    </div>
                    <ul className="link">
                      <li><a href="javascript:void(0)">Home</a></li>
                      <li><a href="javascript:void(0)">Page</a></li>
                      <li><a href="javascript:void(0)">Portfolio</a></li>
                      <li><a href="javascript:void(0)">Blog</a></li>
                      <li><a href="javascript:void(0)">Contact</a></li>
                    </ul>
                  </div> */}
                  {/* <!-- footer wrapper --> */}
                </div>
                {/* <!-- footer link --> */}
              </div>

              <div className="col-lg-3 col-md-5 col-sm-12">
                <div
                  className="footer-contact mt-50 wow fadeIn"
                  data-wow-duration="1s"
                  data-wow-delay="0.8s"
                >
                  <div className="footer-title">
                    <h4 className="title headingsty h4">Contact Us</h4>
                  </div>
                  <ul className="contact">
                    {/* <li>+809272561823</li> */}
                    <li><a href="https://mail.google.com/mail/?view=cm&fs=1&to=airbook.org@gmail.com" target="_blank" style={{ color: "white" }}>airbook.org@gmail.com</a></li>
                    <li>www.airbook.tech</li>
                    {/* <li>
                      123 Stree New York City , United <br />
                      States Of America 750.
                    </li> */}
                  </ul>
                </div>
                {/* <!-- footer contact --> */}
              </div>
            </div>
            {/* <!-- row --> */}
          </div>
          {/* <!-- footer widget --> */}
          <div className="footer-copyright">
            <div className="row">
              <div className="col-lg-12">
                <div className="copyright d-sm-flex justify-content-center">
                  <div className="copyright-content">
                    <p className="text">
                      Powered by AirBook
                    </p>
                  </div>
                  {/* <!-- copyright content --> */}
                </div>
                {/* <!-- copyright --> */}
              </div>
            </div>
            {/* <!-- row --> */}
          </div>
          {/* <!-- footer copyright --> */}
        </div>
        {/* <!-- container --> */}
        <div id="particles-2"></div>
      </footer>
      {/* <!--====== FOOTER PART ENDS ======--> */}

      {/* <!--====== BACK TOP TOP PART START ======--> */}
      <a href="#" className="back-to-top"> <i className="lni lni-chevron-up"> </i> </a>
      {/* <!--====== BACK TOP TOP PART ENDS ======--> */}
    </div>
  );
};

export default Landing;
